import {
  TwoWayService,
} from '../../components/relay-messenger-axios-service/relay-messenger-axios-service';
import { Client } from '@twilio/conversations';
import { TwilioConversation } from '@app/two-way/twilio-conversation.types';

export const fetchAllAssignedChats = async (
  twilioClient: Client
): Promise<TwilioConversation[]> => {
  const pageSize = 500;
  const chatsAssigned = await TwoWayService.getAssignedConversations(
    twilioClient,
  );
  if(chatsAssigned) {
    return TwoWayService.getAllAssignedChats(
      [],
      chatsAssigned,
      pageSize,
    );
  } else {
    return Promise.resolve([]);
  }
};
